import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-m-suspicious-login-validate-code",
	templateUrl: "./suspicious-login-validate-code.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SuspiciousLoginValidateCodeComponent {
	@Input() showErrorMessage: boolean | undefined;

	@Output() validatePin = new EventEmitter();
	@Output() resendPin = new EventEmitter();

	verificationCode: number | undefined;
}
